<!-- Loading Indicator -->
<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 50vh;">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div *ngIf="!isLoading && noDataAvailable" class="no-data-container text-center p-20">
  <div class="d-flex flex-column align-items-center">
    <i-tabler name="info-circle" class="icon-30 text-muted"></i-tabler>
    <h5 class="f-w-600">{{ 'LABEL.NO_DATA' | translate }}</h5>
    <p class="f-w-600 mat-subtitle-1 f-s-16 m-l-10">
    </p>
  </div>
</div>

<div *ngIf="!isLoading && !noDataAvailable">
  <mat-dialog-actions *ngIf="!hideActionButtons"
    class="d-flex justify-content-end align-items-center flex-wrap m-l-5 m-t-5">
    <mat-checkbox [(ngModel)]="showCategory">Category & SubCategory</mat-checkbox>
    <div>
      <a mat-icon-button *ngIf="Prescriptions.length === 0" (click)="printReportDirect()">
        <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
      </a>

      <a mat-icon-button *ngIf="Prescriptions.length > 0" [matMenuTriggerFor]="menu" class="d-flex align-items-center">
        <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
      </a>

      <mat-menu #menu="matMenu">
        <a mat-menu-item (click)="printReportDirect()">All</a>
        <a mat-menu-item (click)="printReportOnly()">Report Only</a>
        <a mat-menu-item (click)="printPrescriptionOnly()">Prescription</a>
      </mat-menu>
    </div>
  </mat-dialog-actions>


  <div class="report-scroll-container">
    <mat-card class="report-card m-l-5">
      <!-- Dynamic Report Section -->
      <div #printbody>
        <div class="dynamic-section">
          <!-- Loop through all report categories first -->
          <div #reportSection>
            <div class="report-container" *ngFor="let group of groupedReports">
              <h4 class="category-type">{{ group.categoryType }}</h4>

              <div *ngFor="let cat of group.categories" class="category-section">
                <div class="report-table m-b-10">
                  <div *ngFor="let sub of cat.subCategories; let i = index" class="report-row">
                    <!-- Category Column -->
                    <div class="left-col" *ngIf="showCategory" [class.first-row]="i === 0">
                      <span *ngIf="i === 0">{{ cat.category }}</span>
                    </div>
                    <!-- SubCategory Column -->
                    <div class="middle-col" *ngIf="showCategory">
                      <span *ngIf="sub.items.length > 0">
                        {{ sub.items[0].subCategoryName }}
                      </span>
                    </div>
                    <!-- Items Column -->
                    <div class="right-col">
                      <div *ngFor="let item of sub.items">
                        &bull; {{ item.clinicalItemName }}
                        <span *ngIf="item.duration"> ({{item.duration}})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Show all prescriptions at the end -->
          <div #prescriptionSection>
            <div *ngIf="Prescriptions.length > 0">

              <img src="/assets/images/svgs/icon-rx.svg" class="logo-rx" />
              <div class="diagnosis-section" *ngIf="isPrescriptionPrint">{{ 'LABEL.DIAGNOSIS' | translate }} : {{
                diagnosisList }}</div>

              <div class="prescription">
                <div class="prescription-header">
                  <div class="cell-prescription drug-col">{{ 'LABEL.DRUG_NAME' | translate }}</div>
                  <div class="cell-prescription pattern-col">{{ 'LABEL.DRUG_PATTERN' | translate }}</div>
                  <div class="cell-prescription duration-col">{{ 'LABEL.DURATION' | translate }}</div>
                  <div class="cell-prescription meal-col">{{ 'LABEL.MEAL_RELATION' | translate }}</div>
                  <div class="cell-prescription instruction-col">{{ 'LABEL.INSTRUCTION' | translate }}</div>
                </div>

                <ng-container *ngFor="let prescription of Prescriptions">
                  <ng-container *ngFor="let item of prescription.prescriptionItems">
                    <div class="prescription-row">
                      <div class="cell-prescription drug-col">{{ getDrugName(item.drugId) }}</div>
                      <div class="cell-prescription pattern-col">{{ item.dosePattern }}</div>
                      <div class="cell-prescription duration-col">{{ item.duration }}</div>
                      <div class="cell-prescription meal-col">{{ item.mealRelation }}</div>
                      <div class="cell-prescription instruction-col">{{ item.instruction }}</div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>

        </div>
      </div>
    </mat-card>
  </div>
</div>